var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgNoIcon = function SvgNoIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0D2976",
    d: "m1.99 3.412 14.574 14.575a1.006 1.006 0 0 0 1.423-1.423L3.413 1.989A1.006 1.006 0 1 0 1.99 3.412M.934 13V7.95h1.25V13zm-.07-6V5.78h1.39V7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0D2976",
    d: "M5.861 13.1q-.78 0-1.37-.32a2.23 2.23 0 0 1-.9-.91q-.32-.6-.32-1.42t.32-1.4q.33-.58.91-.89t1.36-.31q.5 0 .97.16.48.15.78.44l-.38.87a1.7 1.7 0 0 0-.61-.37 1.8 1.8 0 0 0-.65-.13q-.669 0-1.05.42-.37.42-.37 1.22t.37 1.23q.381.43 1.05.43.31 0 .64-.12.34-.12.62-.37l.38.86q-.31.29-.79.45-.47.16-.96.16M10.763 13.1q-.78 0-1.35-.32a2.25 2.25 0 0 1-.89-.91q-.31-.59-.31-1.4t.31-1.39a2.25 2.25 0 0 1 .89-.91q.57-.32 1.35-.32t1.35.32q.58.32.89.91.32.58.32 1.39t-.32 1.4a2.17 2.17 0 0 1-.89.91q-.57.32-1.35.32m0-.96q.59 0 .94-.41.35-.42.35-1.26t-.35-1.25-.94-.41-.94.41-.35 1.25.35 1.26q.35.41.94.41M14.4 13V9.21a10 10 0 0 0-.08-1.26h1.21l.1 1h-.12a1.76 1.76 0 0 1 .71-.81q.47-.29 1.09-.29.89 0 1.34.5t.45 1.56V13h-1.25V9.97q0-.61-.24-.87-.23-.27-.7-.27-.58 0-.92.36t-.34.96V13z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgNoIcon);
export default ForwardRef;